import Vue from 'vue';
import { getters } from '@/mixins/ScreenSizeMixinGetters';

const screenSizeReactiveComponent = new Vue({
  data() {
    return {
      event: null,
      width: null,
      height: null,
    };
  },
});

export const ScreenSizeMixin = {
  computed: {
    screenSizeEvent() {
      return screenSizeReactiveComponent.event;
    },
    screenSizeWidth() {
      return screenSizeReactiveComponent.width || this.getScreenWidth();
    },
    screenSizeHeight() {
      return screenSizeReactiveComponent.height || this.getScreenHeight();
    },
    ...getters({
      sm: 640,
      md: 770,
      lg: 1024,
      xl: 1280,
      xxl: 1800,
    }),
  },
  methods: {
    getScreenWidth() {
      return window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;
    },
    getScreenHeight() {
      return window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;
    },
    handleScreenResize(event) {
      screenSizeReactiveComponent.event = event;
      screenSizeReactiveComponent.width = this.getScreenWidth();
      screenSizeReactiveComponent.height = this.getScreenHeight();
    },

    $vssDestroyListener() {
      window.removeEventListener('resize', this.handleScreenResize);
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleScreenResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleScreenResize);
  },
};
